import React, {useEffect, useRef} from "react";
import {Colors} from "../../../assets/colors/Colors";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import {
  convertToString,
  dateToStringFormat,
  formatDay,
  getFechaToCalendarRange, validArray,
  validateDiasEntregaVisita
} from "../../../util/functions";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import {CalendarFormRange} from "../../../components/ComponentesFormularios/CalendarForm";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import {FormProvider, useForm, useFormContext, useWatch} from "react-hook-form";
import {isEmpty, isObject} from "../../../util/is";
import Tooltip from "@mui/material/Tooltip";
import {modalCRUDService} from "../../../services/modalCRUDService";
import OrdenDiasVisita from "../../../components/OrdenDiasVisita";
import {GlobalConstants} from "../../../data/GlobalConstants";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import {useDispatch, useSelector} from "react-redux";
import {clientesService} from "../../../services/apiClientes";
import {HeaderClientInformation} from "./FormCRUD";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidth,
    optionsEstados,
    ERRORFIELDREQUIRED,
    optionsYesNo,
    optionsFrecuencia,
    optionsPrioridadMercancia
} from "../../../data/ConstantForm";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import {func} from "prop-types";

function convertArrDaysToStringDays(arr, order = false) {

    let stringData = "";

    for(let i = 0; i < arr.length; i++){
        if(convertToString(arr[i]) !== convertToString(-1)){
            if(order){
                stringData += `${arr[i]};`;
            }
            else{
                stringData += `${formatDay(i)};`;
            }
        }
    }

    return stringData.substring(0, stringData.length - 1);

}

function convertToArrRutas(diasVisita, ordenVisita, diasEntrega, ordenEntrega) {

    let arrRutas = [];
    let countDiasVisita = 0;
    for(let i = 0; i < ordenVisita.length; i++){

      if(convertToString(ordenVisita[i]) !== convertToString(-1)){

        arrRutas.push({
          DiaV: formatDay(i),
          OrdV: ordenVisita[i],
          DiaE: "",
          OrdE: ""
        })

        countDiasVisita++;

      }

    }

    let countDiasEntrega = 0;
    for(let i = 0; i < ordenEntrega.length; i++){

      if(convertToString(ordenEntrega[i]) !== convertToString(-1)){

        if(countDiasEntrega < countDiasVisita){
          arrRutas[countDiasEntrega].DiaE = formatDay(i);
          arrRutas[countDiasEntrega].OrdE = ordenEntrega[i];
        }

        countDiasEntrega++;
      }

    }

    return arrRutas;

}

const FormasMediosPago = ({ isEditing, generalServicesState }) => {

  const { setValue, register, handleSubmit, formState: { errors }, control } = useFormContext();

  const formaPago = useWatch({
    control,
    name: "formaPago"
  })

  const ref = useRef(formaPago);

  useEffect(() => {

    if(convertToString(ref.current) !== convertToString(formaPago)){

      if(convertToString(formaPago) === "1"){
        setValue("condicionesPago", "Z000");
        setValue("valorCupo", "0");
        setValue("valorCredito", "0");
      }

    }


  }, [formaPago])


  return(
      <>

        <SelectForm inputProps={{control}} disabled={!isEditing || (convertToString(formaPago) === "1")}
                    identificador="condicionesPago" label="Condiciones Pago"
                    options={generalServicesState?.arrCondicionesPago}  required={convertToString(formaPago) !== "1"} className={`${classResponsiveForm}`}
                    customError={errors.condicionesPago ? ERRORFIELDREQUIRED : null} />

        <InputForm inputProps={{control}} disabled={!isEditing || (convertToString(formaPago) === "1")}
                   identificador="valorCupo" label="Valor Cupo"
                   placeholder="Ej: 1000000" type="number" required={convertToString(formaPago) !== "1"} className={`${classResponsiveForm}`}
                   customError={errors.valorCupo ? ERRORFIELDREQUIRED : null} />

        <InputForm inputProps={{control}} disabled={!isEditing || (convertToString(formaPago) === "1")}
                   identificador="valorCredito" label="Valor Credito"
                   placeholder="Ej: 1000000" type="number" required={convertToString(formaPago) !== "1"} className={`${classResponsiveForm}`}
                   customError={errors.valorCupo ? ERRORFIELDREQUIRED : null} />

      </>
  )

}

const OrdenDiasVisitaForm = ({isEditing}) => {

  const { setValue, formState: { errors }, control } = useFormContext();

  const values = useWatch({
    control,
    name: ["diasVisita", "diasEntrega", "ordenVisita", "ordenEntrega", "idZona"]
  })

  const handleChangeDiasEntregaVisita = (tipo, dia, orden) => {

    let diasVisitaClone = values[0].slice();
    let ordenVisitaClone = values[2].slice();
    let diasEntregaClone = values[1].slice();
    let ordenEntregaClone = values[3].slice();


    if(GlobalConstants.typeVisita === tipo){

      diasVisitaClone[dia] = 1;
      ordenVisitaClone[dia] = orden;
      if(isEmpty(orden)){
        diasVisitaClone[dia] = -1;
        ordenVisitaClone[dia] = -1;
      }
    }
    else if(GlobalConstants.typeEntrega === tipo){
      diasEntregaClone[dia] = 1;
      ordenEntregaClone[dia] = orden;
      if(isEmpty(orden)){
        diasEntregaClone[dia] = -1;
        ordenEntregaClone[dia] = -1;
      }
    }

    setValue("diasVisita", diasVisitaClone);
    setValue("ordenVisita", ordenVisitaClone);
    setValue("diasEntrega", diasEntregaClone);
    setValue("ordenEntrega", ordenEntregaClone);

    Emitter.emit(ConstantEventEmitter.eventCloseModalDiasEntregaVisita);

  }

  return(

    <>

      {
        !isEmpty(values[4]) ?

          <OrdenDiasVisita diasVisita={values[0]} diasEntrega={values[1]} ordenVisita={values[2]} ordenEntrega={values[3]} idZona={isObject(values[4]) ? values[4]?.id : values[4]}
                           onChange={(tipo, dia, orden) => handleChangeDiasEntregaVisita(tipo, dia, orden)} required={true}
                           customError={errors.diasVisita ||  errors.diasEntrega ? ERRORFIELDREQUIRED : null} disabled={!isEditing}/>
          :
          <div className="w-100 p-3 d-flex justify-content-center align-items-center" style={{border: "1px dashed #9c9fa6", borderRadius: 10, backgroundColor: Colors.WHITE}}>

            <p className="p-3 w-50 text-center font-weight-bold" style={{fontSize: 18, color: Colors.RED_SWITCH_INACTIVE}}> Para configurar los días de visita y entrega, debe seleccionar una zona (vendedor) </p>

          </div>
      }

    </>

  )

}

const Tipologia = ({isEditing}) => {

  const dispatch = useDispatch();
  const generalServicesState = useSelector( state => state.generalServices )
  const { control, setValue, formState: { errors } } = useFormContext();

  const values = useWatch({
    control,
    name: "idTipologia"
  })

  useEffect(() => {
    const executeFunction = async() => {
      let vlrTipologia = isObject(values) ? values?.id : values
      const response = await clientesService.getSubCanalByTipologia(vlrTipologia)

      const { status, msg, data } = response

      if(status){
        setValue("canal", data.canal.id)
        setValue("subCanal", data.subcanal.id)
      }else{
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg}})
      }

    }

    executeFunction()

  }, [values])

  return(
    <>
      <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="idTipologia" label="Tipología"
                            options={generalServicesState?.arrTipologias}  required={true} className={classResponsiveForm}
                            customError={errors.idTipologia ? ERRORFIELDREQUIRED : null} />

      <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="canal" label="Canal"
                            options={generalServicesState?.arrCanales}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.canal ? ERRORFIELDREQUIRED : null}/>

      <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="subCanal" label="Sub Canal"
                            options={generalServicesState?.arrSubCanales}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.subCanal ? ERRORFIELDREQUIRED : null}/>
    </>
  )

}

const FormRutaCRUD = ({isEditing, isAddMode, properties}) => {

    const { data, codTercero, idModal, idPuntoVenta, infoCli, function: executeFunction } = properties;
    const dispatch = useDispatch();
    const generalServicesState = useSelector( state => state.generalServices )
    const uiAuth = useSelector( state => state.auth )
    const { idUsuario } = uiAuth;
    const methods = useForm({defaultValues: {
            ...data,
            dtFechaIniFin: getFechaToCalendarRange(data?.dtFechaIni ? data?.dtFechaIni : dateToStringFormat(new Date()), data?.dtFechaFin ? data?.dtFechaFin : '2200-12-31'),
            clasificacion: isEmpty(data?.clasificacion) ? "0" : data.clasificacion,
            prioridadMercancia: isEmpty(data?.prioridadMercancia) ? "1" : data.prioridadMercancia,
            medioPago: isEmpty(data?.medioPago) ? "10" : data.medioPago,
            diasVisita: isEmpty(data?.diasVisita) ? [-1,-1,-1,-1,-1,-1,-1] : data.diasVisita,
            ordenVisita: isEmpty(data?.ordenVisita) ? [-1,-1,-1,-1,-1,-1,-1] : data.ordenVisita,
            diasEntrega: isEmpty(data?.diasEntrega) ? [-1,-1,-1,-1,-1,-1,-1] : data.diasEntrega,
            ordenEntrega: isEmpty(data?.ordenEntrega) ? [-1,-1,-1,-1,-1,-1,-1] : data.ordenEntrega
    }});
    const { register, handleSubmit, setValue, formState: { errors }, control } = methods;



    useEffect(() => {
        register("diasVisita", { validate: value => !isEmpty(validateDiasEntregaVisita(value)) || 'Este Campo es requerido'})
        register("ordenVisita", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
        register("diasEntrega", { validate: value => !isEmpty(validateDiasEntregaVisita(value)) || 'Este Campo es requerido'})
        register("ordenEntrega", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
        register("dtFechaIniFin", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
    },[])



    //FUNCTIONS
    const onSuccessSubmit = data => {

        data.idPuntoVenta = idPuntoVenta;
        data.idEmpresa = isObject(data?.idEmpresa) ? data.idEmpresa.id : data.idEmpresa;
        data.idZona = isObject(data?.idZona) ? data.idZona.id : data.idZona;
        data.idPortafolio = isObject(data?.idPortafolio) ? data.idPortafolio.id : data.idPortafolio;
        data.idListaPrecio = isObject(data?.idListaPrecio) ? data.idListaPrecio.id : data.idListaPrecio;
        data.idTipologia = isObject(data?.idTipologia) ? data.idTipologia.id : data.idTipologia;
        data.canal = isObject(data?.canal) ? data.canal.id : data.canal;
        data.subCanal = isObject(data?.subCanal) ? data.subCanal.id : data.subCanal;
        data.negocio = isObject(data?.negocio) ? data.negocio.id : data.negocio;
        data.grupoPV = isObject(data?.grupoPV) ? data.grupoPV.id : data.grupoPV;
        data.dtFechaIni = dateToStringFormat(data.dtFechaIniFin[0]);
        data.dtFechaFin = dateToStringFormat(data.dtFechaIniFin[1]);
        data.jsItems = {
          arrRutas: validArray(convertToArrRutas(data.diasVisita, data.ordenVisita, data.diasEntrega, data.ordenEntrega))
        };
        /*data.diasVisita = convertArrDaysToStringDays(data.diasVisita);
        data.ordenVisita = convertArrDaysToStringDays(data.ordenVisita, true);
        data.diasEntrega = convertArrDaysToStringDays(data.diasEntrega);
        data.ordenEntrega = convertArrDaysToStringDays(data.ordenEntrega, true);*/
        data.idUsrAuditoria = idUsuario;
        data.accion = isAddMode ? "C" : "A";
        data.beforeTipologia = properties.data.idTipologia

        clientesService.setCrudPuntoVentaItem(data).then(
            response => {

                const {status, msg, data: datos, sync} = response;

                if (status) {
                    if(datos?.idmsg === 200){

                        if(isAddMode){

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: datos?.txmsg } });
                            executeFunction({newState: sync, idPtoVenta: idPuntoVenta});

                        }
                        else{

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: datos?.txmsg } });
                            executeFunction({newState: sync, item: data, idPtoVenta: idPuntoVenta});
                        }

                        modalCRUDService.clear("modalCreateEditRutas");
                    }
                    else{
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: datos?.txmsg } });
                    }


                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                }


            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
            }
        );

    }

    const onErrorSubmit = errors => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Faltan campos obligatorios, por favor válida la información' } });
    }



    return(

        <FormProvider {...methods} >
            <form className="container mx-0 px-0 w-100 mw-100" style={{minHeight: '100vh'}}>

            <div className="d-flex justify-content-between align-items-center px-0">

                <HeaderClientInformation infoCli={infoCli}/>

                <div className="d-flex align-items-center">
                    { isEditing &&
                    <Tooltip title="Guardar" aria-label="guardar">
                        <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                           className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"/>
                        </a>
                    </Tooltip>
                    }
                    <Tooltip title="Cancelar" aria-label="cancelar">
                        <a onClick={() => {modalCRUDService.clear(idModal)}} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>


            <div className="mx-2 mt-2 mb-2 text-center text-muted content-divider divider-form">
                <span/>
            </div>


            <div className="row mx-0 px-0 mt-4 justify-content-between align-items-center">

                    <div className={`${classResponsiveFormDoubleWidth} px-0 d-flex align-items-center`}>
                        <InputForm inputProps={{control}} readOnly={true} disabled={!isEditing} identificador="idPuntoVentaItem" label="Cod. Punto Venta Item"
                                   placeholder="Automatico" type="text" required={!isAddMode} className={`pr-2 w-100`}
                                   customError={errors.idPuntoVentaItem ? ERRORFIELDREQUIRED : null}/>

                        <InputForm inputProps={{control}} readOnly={true} disabled={!isEditing} identificador="idERP" label="Cod. ERP"
                                   placeholder="Automatico" type="text" required={!isAddMode} className={`pl-2 w-100`}
                                   customError={errors.idERP ? ERRORFIELDREQUIRED : null}/>

                    </div>

                    <CalendarFormRange inputProps={{control}} disabled={!isEditing} identificador="dtFechaIniFin" required={true}
                                       label="Fecha Ingreso - Salida" className={`${classResponsiveFormDoubleWidth}`}
                                       customError={errors.dtFechaIniFin ? ERRORFIELDREQUIRED : null}/>


            </div>


            <div className="mx-2 mt-0 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Información Ruta</span>
            </div>
            <div className="row mx-0 px-0 mt-3 mb-1">

                <SelectFormVirtualize  inputProps={{control}} disabled={!isEditing} identificador="idEmpresa"
                                       label="Empresa" options={generalServicesState?.arrEmpresas} required={true}
                                       className={`${classResponsiveForm}`} customError={errors.idEmpresa ? ERRORFIELDREQUIRED : null} />

                <NestedSelectVirtualizeForm isEditing={!isEditing} keyIdentificador="idZona" label="Vendedor" required={true} showId={true}
                                  className={classResponsiveForm} options={generalServicesState?.arrVendedores}
                                  keyFatherValue="idEmpresa" customError={errors.idZona ? ERRORFIELDREQUIRED : null}/>


                <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="idPortafolio" label="Portafolio"
                            options={generalServicesState?.arrPortafolios}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.idPortafolio ? ERRORFIELDREQUIRED : null}/>

                <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="idListaPrecio" label="Lista de precios"
                            options={generalServicesState?.arrListaPrecios} required={true} className={`${classResponsiveForm}`}
                            customError={errors.idListaPrecio ? ERRORFIELDREQUIRED : null}/>

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="idFrecuencia" label="Frecuencia"
                            options={generalServicesState?.arrFrecuencias}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.idFrecuencia ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="idEstado" options={optionsEstados} required={true}
                            defaultValue="1" label="Estado" className={`w-auto`}
                            customError={errors.idEstado ? ERRORFIELDREQUIRED : null}/>

            </div>

            <div className="row mx-0 px-0 mt-1 mb-2">

              <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="negocio" label="Propietario"
                                    options={generalServicesState?.arrPropietario} required={true} className={`${classResponsiveFormDoubleWidth}`}
                                    customError={errors.negocio ? ERRORFIELDREQUIRED : null}/>

            </div>


            <OrdenDiasVisitaForm isEditing={isEditing} />


            <div className="mx-2 mt-4 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Clasificación</span>
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2 align-items-center">

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="clasificacion" label="Clasificacion Punto"
                            options={generalServicesState?.arrClasificacionesPunto}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.clasificacion ? ERRORFIELDREQUIRED : null} />

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="segmentoNecesidad" label="Segmento Necesidad"
                            options={generalServicesState?.arrSegmentosNecesidad}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.segmentoNecesidad ? ERRORFIELDREQUIRED : null} />

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="etiqueta" label="Etiqueta"
                            options={generalServicesState?.arrEtiquetas}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.etiqueta ? ERRORFIELDREQUIRED : null} />

                <Tipologia isEditing={isEditing}/>


                {/* <NestedSelectVirtualizeForm isEditing={true} keyIdentificador="subCanal" label="Sub Canal" required={true}
                                  className={classResponsiveForm} options={generalServicesState?.arrSubCanales}
                                  keyFatherValue="canal" customError={errors.subCanal ? ERRORFIELDREQUIRED : null}/> */}
            </div>

            <div className="row mx-0 px-0 mt-1 mb-2">

              <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="grupoPV" label="Grupo 5"
                                    options={generalServicesState?.arrGrupoPV?.filter(x=> x?.tipo === "GRUPO 5: TAMAÑO MERCADO")}
                                    required={true} className={`${classResponsiveForm}`}
                                    customError={errors.grupoPV ? ERRORFIELDREQUIRED : null}/>

            </div>

            <div className="mx-2 mt-0 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Formas y medios de pago</span>
            </div>
            <div className="row mx-0 px-0 mt-3 mb-2">

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="formaPago" label="Forma de pago"
                          options={generalServicesState?.arrFormasPago}  required={true} className={`${classResponsiveForm}`}
                          customError={errors.formaPago ? ERRORFIELDREQUIRED : null} />

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="medioPago" label="Medio de pago"
                          options={generalServicesState?.arrMediosPago}  required={true} className={`${classResponsiveForm}`}
                          customError={errors.medioPago ? ERRORFIELDREQUIRED : null} />

                <FormasMediosPago isEditing={isEditing} generalServicesState={generalServicesState} />

            </div>

            <div className="mx-2 mt-0 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Otros</span>
            </div>
            <div className="row mx-0 px-0 mt-3 mb-2">

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="productosSustitutos" options={optionsYesNo} required={true}
                                 defaultValue="S" label="Productos Sustitutos" className={`${classResponsiveForm}`}
                                 customError={errors.productosSustitutos ? ERRORFIELDREQUIRED : null}/>

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="prioridadMercancia" label="Prioridad Mercancia"
                            options={optionsPrioridadMercancia}  required={true} className={`${classResponsiveForm}`}
                            customError={errors.prioridadMercancia ? ERRORFIELDREQUIRED : null}/>

            </div>

        </form>
        </FormProvider>



    )

}

export default FormRutaCRUD;
